import {BillingRulesService} from 'services/billingRulesServices';
import {createEntityThunks} from 'utils/createEntityThunks';
import {BillingRule} from 'types/billingRule';

export const BillingRulesThunks = createEntityThunks<BillingRule>(
  'billingRules',
  BillingRulesService,
  {activate: true, deactivate: true},
);
